import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Select, SelectItem } from "framework/controls/select";
import { cls_filter_item_box, cls_filter_item_box_small_for_mobile } from "./view.css";
import { cls_form_area_box } from "style/form.css";
import { cls_gap_form, cls_wrap } from "style/index.css";
import { cls_align_items_flex_start, cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
import { useResponsivity } from "framework/responsivity/store";
import { useResultsFilterState } from "../store";
import { getEntityField } from "framework/state/setfield";
var Content = function () {
    var _a = useResultsFilterState(), filter_state = _a[0], actions = _a[1];
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var cls_item_box = T_HFM ? cls_filter_item_box_small_for_mobile : cls_filter_item_box;
    var year_min = 2010;
    var months = [
        { "key": 1, "value": "Leden" },
        { "key": 2, "value": "Únor" },
        { "key": 3, "value": "Březen" },
        { "key": 4, "value": "Duben" },
        { "key": 5, "value": "Květen" },
        { "key": 6, "value": "Červen" },
        { "key": 7, "value": "Červenec" },
        { "key": 8, "value": "Srpen" },
        { "key": 9, "value": "Září" },
        { "key": 10, "value": "Říjen" },
        { "key": 11, "value": "Listopad" },
        { "key": 12, "value": "Prosinec" },
    ];
    var this_year = new Date().getFullYear();
    var years = [];
    for (var y = this_year; y >= year_min; y--) {
        years.push(y);
    }
    var getter = function (field) {
        var _a;
        return (_a = getEntityField(filter_state, field)) === null || _a === void 0 ? void 0 : _a.toString();
    };
    var setter = function (field, value, validator, storeInvalidValue) {
        return actions.setFilterEntityField(field, value, validator, storeInvalidValue);
    };
    return React.createElement(HBox, null,
        React.createElement(VBox, { className: [cls_gap_form, cls_align_items_flex_start] },
            React.createElement(HBox, { className: [cls_gap_form, cls_wrap] },
                React.createElement(VBox, { className: [cls_item_box, cls_align_items_stretch] },
                    React.createElement(Select, { name: "year", label: "Rok", state: filter_state, getter: getter, setter: setter }, years.map(function (x) { return React.createElement(SelectItem, { key: x, value: x.toString(), children: x.toString() }); }))),
                React.createElement(VBox, { className: [cls_item_box, cls_align_items_stretch] },
                    React.createElement(Select, { name: "month", label: "M\u011Bs\u00EDc", state: filter_state, getter: getter, setter: setter }, months.map(function (x) { return React.createElement(SelectItem, { key: x.key, value: x.key.toString(), children: x.value }); }))))));
};
var View = function () {
    return React.createElement(HBox, null,
        React.createElement(VBox, { className: cls_form_area_box },
            React.createElement(Content, null)));
};
export { View as Filter, };
